import { AuthData } from './../models/authdata';
import {of as observableOf,  Observable, ReplaySubject, BehaviorSubject } from 'rxjs';
import { Component, Injectable, Inject, OnInit } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { tap, observeOn } from 'rxjs/operators';



@Injectable()
export class AuthService implements CanActivate {
  private myAppUrl: string;
  public authDataCache: AuthData;
  public authIsLoaded: Promise<boolean>;
  public authDataPromise: Observable<AuthData>;
  private isAuthorized = new ReplaySubject<boolean>(1);

  constructor(private router: Router, private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
    this.myAppUrl = baseUrl;
    // this.admin = false;
    // this.gestor = false;
    // this.validador = false;
    // this.tecnico = false;
    this.estadoSetUp();
  }

  private estadoSetUp() {
    this.authDataPromise = this.getAuthData();

    this.authDataPromise.subscribe( (d: AuthData) => {
      this.authDataCache = d;
      this.authIsLoaded = Promise.resolve(true);
      this.isAuthorized.next(d.amILogin);
    }, err => console.log(err));
  }

  public getAuthData(): Observable<AuthData> {
    return this.http.get<AuthData>(this.myAppUrl + 'api/IsAuthenticated');
  }

  public canActivate(): Observable<boolean> {
    return this.isAuthorized.asObservable().pipe(
      tap(auth => {
      if (auth !== true) {
        this.router.navigate(['/']);
      }
    }));
  }


}
